// src/components/Chat/ChatHeader.js

import React, { useEffect, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencilAlt } from '@fortawesome/free-solid-svg-icons';

const ChatHeader = ({ title, editor }) => {
  const titleInputRef = useRef(null);

  useEffect(() => {
    // Автофокус на поле ввода при редактировании заголовка
    if (editor.isEditing && titleInputRef.current) {
      titleInputRef.current.focus();
    }
  }, [editor.isEditing]);

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      editor.submit();
    } else if (e.key === 'Escape') {
      editor.cancelEditing();
    }
  };

  return (
    <div className="chat-header d-flex justify-content-between align-items-center border-bottom">
      <div className="d-flex align-items-center">
        {editor.isEditing ? (
          <div className="input-group">
            <input
              type="text"
              className="form-control"
              name="chatTitle"
              value={editor.value}
              onChange={(e) => editor.setValue(e.target.value)}
              onBlur={editor.submit}
              onKeyDown={handleKeyDown}
              ref={titleInputRef}
            />
            <button
              className="btn btn-outline-secondary"
              type="button"
              onClick={editor.submit}
            >
              Сохранить
            </button>
          </div>
        ) : (
          <h5 className="mb-0 d-flex align-items-center">
            {title}
            <button
              className="btn btn-sm text-secondary border-0 ms-2"
              onClick={editor.startEditing}
              title="Редактировать название"
            >
              <FontAwesomeIcon icon={faPencilAlt} />
            </button>
          </h5>
        )}
      </div>
      <div className="header-controls">
        {/* Это место остаётся для будущих элементов управления в хедере */}
      </div>
    </div>
  );
};

export default ChatHeader;